<template>
  <!--  <router-link-->
  <!--      v-bind="$props"-->
  <!--      :to="{name:'EditTask',params:{taskId:task.id}}"-->
  <!--      custom-->
  <!--      v-slot="{  href }"-->
  <!--  >-->
  <ion-item-sliding :ref="sliderId()" @ionDrag="dragged">

    <ion-item @click="goToTask" routerAnimation>


      <ion-label>
        <ion-icon :icon="checkmark" v-if="selected"/>
        <p style="display: inline;">{{ time(itemTask) }}</p> <span :class="priorityClass(itemTask)">{{ itemTask.name }}</span>
        <p >{{toolsAsString(itemTask)}}</p>
        <div style="margin-top:10px;">
          <ion-badge :color="stateColor(itemTask)">{{ itemTask.state }}</ion-badge>
          <ion-badge color="tertiary">#{{ getCategory(itemTask) }}</ion-badge>
          <ion-icon :icon="timer" :color="durationColor(itemTask)" style="height: 20px; width:20px; margin-right: 10px;" />
          <ion-icon :icon="cog" :color="difficultyColor(itemTask)" style="height: 20px; width:20px;" />
        </div>

      </ion-label>

    </ion-item>
    <ion-item-options v-if="showReview" side="start">
      <ion-item-option @click="$emit('createReview')">
        {{ t("addreview") }}
      </ion-item-option>
    </ion-item-options>

    <ion-item-options side="end" v-if="!readOnly">
      <ion-item-option v-if="itemTask.state!==todoState" color="warning" @click="toTodo()">
        {{ t("taskstate.todo") }}
      </ion-item-option>
      <ion-item-option v-if="itemTask.state!==doingState" color="primary" @click="toDoing()">
        {{ t("taskstate.doing") }}
      </ion-item-option>
      <ion-item-option v-if="itemTask.state!==doneState" color="success" @click="toDone()">
        {{ t("taskstate.done") }}
      </ion-item-option>
    </ion-item-options>
  </ion-item-sliding>
  <!--  </router-link>-->
</template>

<script lang="ts">

import {defineComponent} from "vue";
import {IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonBadge, IonIcon} from "@ionic/vue";
import {Category, createEmptyTask, I18nUtils, Task, TaskState, TaskUtils} from "@/store/state";
import {useStore} from "@/store/store";
import {useI18n} from "vue-i18n";
import {checkmark, timer, cog} from "ionicons/icons";
import {useRouter} from "vue-router";

export default defineComponent({
  name: 'TaskItem',
  props: {
    task: Object as () => Task,
    showReview: {
      type: Boolean,
      required: false,
      default: false
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

  },
  data(props) {
    let itemTask: Task = createEmptyTask(0)
    if (props.task)
      itemTask = {...props.task}
    return {
      itemTask
    }
  },
  components: {

    IonItem,
    IonLabel,
    IonItemOptions,
    IonItemOption,
    IonItemSliding,
    IonBadge,
    IonIcon
    // RouterLink
  },
  methods: {
    sliderId() {
      return "sliding" + this.itemTask.id
    },
    toDone() {

      this.toState(TaskState.Done)
    },
    toDoing() {
      this.toState(TaskState.Doing)
    },
    toTodo() {
      this.toState(TaskState.ToDo)
    },
    toState(s: TaskState) {
      if (this.task) {
        const editTask: Task = {...this.itemTask, state: s}

        this.store.dispatch('updateTask', editTask).then(_ => {
          const sliding = (this.$refs[this.sliderId()] as any)
          sliding.$el.close().then(() => {

            this.itemTask = {...editTask}
          })
        })
      }
    },
    time (t: Task){
      return TaskUtils.asDate(t.deadline).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit',timeZone: 'UTC'});
    },
    getCategory(t: Task) {
      if (t.category == '--own--') {
        return t.customCategory
      }
      const category = this.store.state.categories.filter((c: Category) => c.id === t.category);
      if (category.length > 0) return I18nUtils.toString(category[0].i18nTitle)
      else return "--";
    },
    stateColor(t: Task) {
      if (t.state === TaskState.Done) return "success";
      if (t.state === TaskState.Doing) return "primary";
      if (t.state === TaskState.ToDo) return "warning";
      return "tertiary";
    },
    durationColor(t: Task) {
      if (t.duration <= 15 * 60) return "success";
      if (t.duration <= 60 * 60) return "primary";
      return "warning";
    },
    difficultyColor(t: Task) {
      if (t.difficulty == 1) return "warning";
      if (t.difficulty == 2) return "primary";
      if (t.difficulty == 3) return "success";
      return "primary";
    },
    toolsAsString(t: Task){
      if(!t.usedTools) return "";
      let usedTools: string[] = [];
      if(t.usedTools) usedTools = t.usedTools;
      const result = this.store.state.tools.filter(tool => usedTools.indexOf(tool.id)>-1).map(tool => I18nUtils.toString(tool.i18nShortTitle))
      if(result) return result.join(', ');
      return "";
    },
    priorityClass(t: Task){
      return "priority-"+t.priority;
    },
    goToTask() {
      console.log("gototask")
      if (!this.readOnly)
        this.router.push({name: 'EditTask', params: {taskId: this.itemTask.id}})
      else {
        this.selected = !this.selected;
        if (this.selected) this.$emit('selected');
        else this.$emit('unselected');
      }
    },
    dragged(e: CustomEvent) {
      if (e.detail.ratio == -1) {
        this.$emit('opened')
      } else {
        this.$emit('closed')
      }
    }
  },
  computed: {

    doneState(): TaskState {
      return TaskState.Done
    },
    doingState(): TaskState {
      return TaskState.Doing
    },
    todoState(): TaskState {
      return TaskState.ToDo
    },

  },
  watch: {
    task: {
      handler(n: Task, o: Task) {
        this.itemTask = {...n}
      },
      immediate: true
    }
  },
  setup() {
    const store = useStore();
    const {t} = useI18n();
    const router = useRouter();
    return {
      store, t, router,
      selected: false,
      checkmark, timer, cog
    }
  }

})
</script>
<style scoped>
.active {
  font-weight: bold;
}

ion-badge {
  margin-right: 10px;
}
.priority-1{
  font-weight: bold;
}
.priority-3{
  font-weight: lighter;
}
</style>